export default __webpack_public_path__ + "static/media/36_zaanse.412863bd.jpg";